import React from "react";
import { useRouter } from "next/router";
import { Hooks } from "@xt/xtbase";
import homeActiveIcon from "@/assets/img/proptrading/home-active.svg";
import homeInactiveIcon from "@/assets/img/proptrading/home-inactive.svg";
import rankingActiveIcon from "@/assets/img/proptrading/ranking-active.svg";
import rankingInactiveIcon from "@/assets/img/proptrading/ranking-inactive.svg";
import tradeActiveIcon from "@/assets/img/proptrading/trade-active.svg";
import tradeInactiveIcon from "@/assets/img/proptrading/trade-inactive.svg";
import accountActiveIcon from "@/assets/img/proptrading/account-active.svg";
import accountInactiveIcon from "@/assets/img/proptrading/account-inactive.svg";
import styles from "./index.module.scss";

const { useTranslation } = Hooks;

export type ProptradingTabKey = "home" | "ranking" | "trade" | "account";

/** Prop Trading 交易页固定使用的 CFD 交易对（USDX 报价） */
const PROP_TRADING_SYMBOL = "btc_usdx_cfd";

/**
 * 底部 Tab 配置
 * label 由 useTranslation 提供多语言支持，避免硬编码中文
 */
const TABS: { key: ProptradingTabKey; labelKey: string; path: string; iconSrc: string; iconActiveSrc?: string }[] = [
  { key: "home", labelKey: "proptrading.bottom.home", path: "/proptrading", iconSrc: homeInactiveIcon, iconActiveSrc: homeActiveIcon },
  { key: "ranking", labelKey: "proptrading.bottom.ranking", path: "/proptrading/ranking", iconSrc: rankingInactiveIcon, iconActiveSrc: rankingActiveIcon },
  {
    key: "trade",
    labelKey: "proptrading.bottom.trade",
    path: `/proptrading/trade/${PROP_TRADING_SYMBOL}`,
    iconSrc: tradeInactiveIcon,
    iconActiveSrc: tradeActiveIcon,
  },
  { key: "account", labelKey: "proptrading.bottom.account", path: "/proptrading/account", iconSrc: accountInactiveIcon, iconActiveSrc: accountActiveIcon },
];

const ProptradingBottomBar: React.FC<{ activeTab?: ProptradingTabKey }> = ({ activeTab = "home" }) => {
  const router = useRouter();
  const { t } = useTranslation();

  const handleTab = (tabKey: ProptradingTabKey) => {
    const locale = router.locale && router.locale !== "default" ? router.locale : "";
    const basePath = TABS.find((t) => t.key === tabKey)?.path || "/proptrading";
    const path = locale ? `/${locale}${basePath}` : basePath;
    router.push(path);
  };

  return (
    <nav className={styles.bar}>
      <div className={styles.tabsRow}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          const iconSrc = tab.iconActiveSrc && isActive ? tab.iconActiveSrc : tab.iconSrc;
          return (
            <button
              key={tab.key}
              type="button"
              className={styles.tab}
              data-active={isActive}
              onClick={() => handleTab(tab.key)}
            >
              <img src={iconSrc} alt="" className={styles.icon} />
              <span className={styles.label}>{t(tab.labelKey)}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default ProptradingBottomBar;
